module.exports = __webpack_public_path__ + "img/overdue_dark.2171bf1e.svg";